//client/src/components/indicadores/ReportTable.js
import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Componente de tabela reutilizável para exibir dados de relatórios.
 * @param {object} props
 * @param {string} props.title - O título a ser exibido no cabeçalho da tabela.
 * @param {object[]} props.columns - A configuração das colunas (ex: [{ key, header, render }]).
 * @param {object[]} props.data - O array de dados a ser renderizado.
 * @param {boolean} props.isLoading - Booleano que indica se os dados estão sendo carregados.
 * @param {function} [props.onRowClick] - Opcional. Quando fornecida, cada linha vira clicável (ex.: abrir um painel de detalhe). Páginas que não passam continuam com linhas não-interativas, idêntico a antes.
 */
const ReportTable = ({ title, columns, data, isLoading, onRowClick }) => {

    const renderTableHeader = () => (
        <thead>
            <tr>
                {columns.map((col) => (
                    <th key={col.key} style={col.style || {}}>{col.header}</th>
                ))}
            </tr>
        </thead>
    );

    const renderTableBody = () => (
        <tbody>
            {data.map((row, index) => (
                <tr
                    key={index}
                    onClick={onRowClick ? () => onRowClick(row) : undefined}
                    style={onRowClick ? { cursor: 'pointer' } : undefined}
                >
                    {columns.map((col) => (
                        <td key={col.key} style={col.style || {}}>{col.render(row)}</td>
                    ))}
                </tr>
            ))}
        </tbody>
    );

    const renderEmptyState = () => (
        <div className="panel-state-wrapper panel-info" style={{ minHeight: '200px' }}>
            <p>Nenhum dado encontrado para o período ou filtros selecionados.</p>
        </div>
    );

    const renderLoadingState = () => (
        <div className="panel-state-wrapper" style={{ minHeight: '200px' }}>
            <Loader2 size={24} className="animate-spin icon" />
            <p>Carregando dados do relatório...</p>
        </div>
    );

    return (
        // Usamos o seu .table-container como o wrapper principal
        <div className="table-container">
            {title && (
                <div className="table-header">
                    <h2>{title}</h2>
                    {/* Pode adicionar um botão de refresh aqui se desejar no futuro */}
                </div>
            )}
            <div className="table-wrapper">
                {isLoading ? (
                    renderLoadingState()
                ) : (data && data.length > 0) ? (
                    <table className="styled-table">
                        {renderTableHeader()}
                        {renderTableBody()}
                    </table>
                ) : (
                    renderEmptyState()
                )}
            </div>
        </div>
    );
};

export default ReportTable;